import { Get } from "../utils/api";
import { useQuery } from "react-query";
import { useAuth0 } from "@auth0/auth0-react";

export interface OrderTerms {
  id: string;
  organization_id: string;
  new_customer_min: number | null;
  returning_customer_min: number | null;
  returning_customer_min_cents: number | null;
  new_customer_min_cents: number | null;
}

export default (orgId: string | undefined) => {
  const { getAccessTokenSilently } = useAuth0();
  return useQuery<OrderTerms>(
    `order_terms_${orgId}`,
    async () => {
      return await Get<OrderTerms>(`/api/organization/${orgId}/order_terms`, await getAccessTokenSilently());
    },
    {
      enabled: !!orgId,
    }
  );
};
